import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

import { ButtonIconStyled } from '../Styles/Buttons.styles';
import { ButtonDownloadStyled } from './ButtonsDownloadExcel.styled';

export const ButtonDownloadExcel = ({ handleExportExcel, isDisabled }) => (
  <ButtonDownloadStyled onClick={handleExportExcel} disabled={isDisabled}>
    <ButtonIconStyled icon={faFileExport} />
  </ButtonDownloadStyled>
);

ButtonDownloadExcel.propTypes = {
  handleExportExcel: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
};
